module.exports = __webpack_public_path__ + "img/wuyou_xiangqing_anquan.89614e14.png";